export default {
    black:  'black',
    submit: 'submit',
};